import React from 'react';
import { Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const BreakView = props => {
  const { breakLabel, breakLinkClassName, breakHandler, getEventListener } = props;

  return (
    <Flex alignItems="center" as="li">
      <a
        className={breakLinkClassName}
        role="button"
        tabIndex="0"
        onKeyPress={breakHandler}
        {...getEventListener(breakHandler)}
      >
        {breakLabel}
      </a>
    </Flex>
  );
};

BreakView.propTypes = {
  breakLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  breakClassName: PropTypes.string,
  breakLinkClassName: PropTypes.string,
  breakHandler: PropTypes.func.isRequired,
  getEventListener: PropTypes.func.isRequired
};

export default BreakView;
